export default __webpack_public_path__ + "static/media/footer2.de20a2d7.png";